var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 160",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M87.7,84.1c-1.3-0.3-2.7,0.3-3.4,1.5l-14,26c-0.2,0.4-0.4,0.9-0.4,1.4v4c0,1.7,1.3,3,3,3h11v4c0,1.7,1.3,3,3,3s3-1.3,3-3   v-4c1.7,0,3-1.3,3-3s-1.3-3-3-3V87C90,85.6,89.1,84.4,87.7,84.1z M84,114h-8v-0.2l8-14.9V114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65,116V95c0-6.1-4.9-11-11-11s-11,4.9-11,11v21c0,6.1,4.9,11,11,11S65,122.1,65,116z M49,116V95c0-2.8,2.2-5,5-5   s5,2.2,5,5v21c0,2.8-2.2,5-5,5S49,118.8,49,116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15,113v4c0,1.7,1.3,3,3,3h11v4c0,1.7,1.3,3,3,3s3-1.3,3-3v-4c1.7,0,3-1.3,3-3s-1.3-3-3-3V87c0-1.4-0.9-2.6-2.3-2.9   c-1.3-0.3-2.7,0.3-3.4,1.5l-14,26C15.1,112,15,112.5,15,113z M21,113.8l8-14.9V114h-8V113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119,109V43c0-1.7-1.3-3-3-3s-3,1.3-3,3v66c0,3.9-3.1,7-7,7c-1.7,0-3,1.3-3,3s1.3,3,3,3C113.2,122,119,116.2,119,109z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29,19v48c0,1.7,1.3,3,3,3s3-1.3,3-3V19c0-3.9,3.1-7,7-7l51,0v7c0,7.2,5.8,13,13,13h8.4c1.7,0,4.6,0,4.6-3   c0-12.7-10.3-23-23-23L42,6C34.8,6,29,11.8,29,19z M99,12.3c7,1.2,12.5,6.8,13.7,13.7c-2.9,0-6.7,0-6.7,0c-3.9,0-7-3.1-7-7V12.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.0448dd10f3385945d41e5d62d5827d75.svg";
export { ForwardRef as ReactComponent };